<div class="container-WCB mr-1">
  <div class="infoModal-WCB mb-16 px-5 py-9" *ngIf="show" (click)="$event.stopPropagation()">
    <p class="title-header">
      <b [innerHTML]="resource.webcallback.titleHeader"></b>
    </p>
    <hr />
    <p class="title-WCB px-2" [innerHTML]="resource.webcallback.title"></p>
    <div class="mx-4 my-4 button-CB flex" (click)="callClientService()">
      <img
        class="my-auto ml-6 mr-1"
        [src]="resource.webcallback.logo"
        alt="{{ resource.webcallback.alt_logo }}" />
      <span class="titleButton-CB my-auto ml-3 mr-2" [innerHTML]="phoneNumber"></span>
    </div>
    <p class="title-WCB px-10">
      {{ resource.webcallback.subtitle }}
      <br />
      <b [innerHTML]="resource.webcallback.subtitleB"></b>
    </p>
  </div>
  <button
    title="{{ resource.webcallback.titleHeader }}"
    class="button-WCB"
    (click)="clickFunction(); $event.stopPropagation()"
    matomoClickAction="web-callback">
    <img
      class="mx-auto my-auto"
      [src]="resource.webcallback.logo"
      alt="{{ resource.webcallback.alt_logo }}" />
  </button>
</div>
